<template>

  <div class="home-page sixftapart-page">
    <Header></Header>
    <section class="hero-section background-fit" v-if="campaignDetail" :style="{ backgroundImage: `url(${imageUrl + campaignDetail.imagePath})` }">
      <div class="container">
        <div class="row">
          <div class="col-md-12 hero-col">
            <div class="hero-blk text-center">
              <h2>{{campaignDetail.title}}</h2>
              <p>{{campaignDetail.description}}</p>
              <div class="hero-action-blk">
                <router-link class="join-c" v-if="!logedIn" to="/signup">Signup to submit your video</router-link>
                <a href="javascript:void(0)" v-if="logedIn" class="join-c" data-toggle="modal" data-target="#staticBackdrop">Submit your video here</a>
              </div>
            </div>
          </div>
        </div>
        <div class="row row-2">
          <div class="col-md-6">
            <h3>HOSTED BY:</h3>
            <div class="h-p">
              <router-link :to="`/artists/` + campaignDetail.artist[0]._id + `/`" class="p-img background-fit" :style="{ backgroundImage: `url(${imageUrl + campaignDetail.artist[0].profiles[0].images[0].profileImageFile})` }"></router-link>
              <router-link :to="`/artists/` + campaignDetail.artist[0]._id + `/`">{{campaignDetail.artist[0].name}}</router-link>
            </div>
          </div>
          <div class="col-md-6">
            <div class="float-right">
              <h3>SPONSORED BY:</h3>
              <img src="@/assets/img/main-logo.png" width="130"
                   style="margin-right: 20px;">
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="fc-section pb-5" v-if="videos">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>#{{campaignDetail.campaign}} Submissions</h2>
          </div>
        </div>
        <div class="row">
          <div v-if="(list.imagePath && list.videoPath && list.featured) || (list.imagePath && list.youtube && list.featured)" class="col-md-4 fc-col background-fit" :style="{ backgroundImage: `url(${imageUrl + list.imagePath})` }" v-for="(list) in videos" v-bind:key="list.id">
            <div class="inner-blk">
              <div class="i-blk">
                <router-link :to="`/artists/` + list.artistId._id + `/`" class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.artistId.profiles[0].images[0].profileImageFile})` }"></router-link>
                <div class="p-detail">
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <span data-toggle="modal" v-on:click="playVideo(imageUrl + list.videoPath, imageUrl + list.imagePath, list.youtube)" data-target="#showVideo" style="top:25px;cursor: pointer;"><img src="@/assets/img/next-arrow-white.svg" width="40" /></span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="(list.imagePath && list.videoPath && !list.featured) || (list.imagePath && list.youtube && !list.featured)" class="col-md-4 fc-col background-fit" :style="{ backgroundImage: `url(${imageUrl + list.imagePath})` }" v-for="(list) in videos" v-bind:key="list.id">
            <div class="inner-blk">
              <div class="i-blk">
                <router-link :to="`/artists/` + list.artistId._id + `/`" class="profile-p background-fit" :style="{ backgroundImage: `url(${imageUrl + list.artistId.profiles[0].images[0].profileImageFile})` }"></router-link>
                <div class="p-detail">
                  <h3>{{list.title}}</h3>
                  <p>{{list.created | formatDate}}</p>
                  <span data-toggle="modal" v-on:click="playVideo(imageUrl + list.videoPath, imageUrl + list.imagePath, list.youtube)" data-target="#showVideo" style="top:25px;cursor: pointer;"><img src="@/assets/img/next-arrow-white.svg" width="40" /></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="modal fade" id="staticBackdrop" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5  class="modal-title" id="staticBackdropLabel">Upload Your Video</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <VideoUpload :campaignId="campaignId" />
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade" id="showVideo" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="staticBackdropLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding-top: 0">
            <video-player v-if="videoFlag"  class="video-player-box stg-detail-i"
            ref="videoPlayer"
            :options="playerOptions"
            :playsinline="true"
            customEventName="customstatechangedeventname"

            @play="onPlayerPlay($event)"
            @pause="onPlayerPause($event)"
            @statechanged="playerStateChanged($event)"
            @ready="playerReadied">
            </video-player>
            <iframe style="width: 100%;height:400px;" v-if="youtubeFlag" :src="`https://www.youtube.com/embed/`+youtube" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../components/Header'
import Footer from '../components/Footer'
import axios from 'axios'
import backgroundUrl from '@/assets/img/image7.jpeg'
import backgroundUrl4 from '@/assets/img/image4.jpg'
import backgroundUrl5 from '@/assets/img/image5.svg'
import backgroundUrl6 from '@/assets/img/banners/img1.jpg'
import VideoUpload from "../components/include/videoUpload"
import Vue from 'vue'
import $ from "jquery"
import router from '../router'
import 'video.js/dist/video-js.css'
import { videoPlayer } from 'vue-video-player'
export default {
  name: 'Campaign',
  components: {
    'VideoUpload': VideoUpload,
    'Header': Header,
    'Footer': Footer,
      videoPlayer
  },
  mounted () {
      var userdata = localStorage.getItem('cbs_usertoken')
      if(userdata){
          userdata = JSON.parse(userdata)
          this.logedIn = true
          this.userData = userdata
      }
      var $this = this
      $('#showVideo').on('hidden.bs.modal', function () {
          if($this.youtubeFlag){
              $this.youtubeFlag = false
          } else {
              $this.videoFlag = false
          }
      })
      axios
          .get('/getFeaturedStages')
          .then(response => {
              this.featuredStages = response.data
          })
          .catch(error => console.log(error))
      axios
          .get('/getCampaignById', {
            params: {
                campaignId: this.campaignId
            }
          })
          .then(response => {
              this.campaignDetail = response.data
          })
          .catch(error => console.log(error))
      axios
          .get('/getSixFeetApartVideos', {
              params: {
                  campaignId: this.campaignId
              }
          })
          .then(response => {
              this.videos = response.data
              this.playerOptions = {
                  muted: false,
                  language: 'en',
                  playbackRates: [0.7, 1.0, 1.5, 2.0],
                  sources: [{
                      type: "video/mp4",
                      src: ''
                  }],
                  poster: this.imageName
              }

          })
          .catch(error => console.log(error))
  },
    computed: {
        player() {
            return this.$refs.videoPlayer.player
        }
    },
    methods: {
        playVideo: function (video, image, youtube){
            if(youtube && youtube.includes('youtube')){
                let uri = youtube.split('?')
                if (uri.length == 2)
                {
                    let vars = uri[1].split('&')
                    let getVars = {}
                    let tmp = ''
                    vars.forEach(function(v){
                        tmp = v.split('=')
                        if(tmp.length == 2)
                            getVars[tmp[0]] = tmp[1]
                    })
                    this.youtubeFlag = true
                    this.youtube = getVars.v
                    // do
                }
            } else {
                this.videoFlag = true
                this.playerOptions = {
                    muted: false,
                    language: 'en',
                    playbackRates: [0.7, 1.0, 1.5, 2.0],
                    sources: [{
                        type: "video/mp4",
                        src: video
                    }],
                    poster: image
                }
            }
        },
        // listen event
        onPlayerPlay(player) {
            console.log('player play!', player)
        },
        onPlayerPause(player) {
            console.log('player pause!', player)
        },
        // ...player event

        // or listen state event
        playerStateChanged(playerCurrentState) {
            console.log('player current update state', playerCurrentState)
        },

        // player is ready
        playerReadied(player) {
            console.log('the player is readied', player)
            // you can use it to do something...
            // player.[methods]
        }
    },
  data () {
    return {
        backgroundUrl: backgroundUrl,
        backgroundUrl4: backgroundUrl4,
        backgroundUrl5: backgroundUrl5,
        backgroundUrl6: backgroundUrl6,
        featuredStages: '',
        videos: '',
        youtubeFlag: false,
        videoFlag: false,
        youtube: '',
        userData: '',
        playerOptions: '',
        campaignDetail: '',
        campaignId: router.history.current.params.id,
        imageUrl: process.env.imageUrl,
        logedIn: false,
        msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/campaign.vue